module.exports = __webpack_public_path__ + "mainassets/img/meshlin_main-vector.011fe702.svg";